
namespace RioERP.Masters {
    export class SmsTemplatesColumns {
        static columnsKey = 'Masters.SmsTemplates';
    }
}